// =============================================================================
//  Copyright : 2023 semantics GmbH
//  Date      : $Date: 2023-03-28 15:11:23 +0200 (Tue, 28 Mar 2023) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 133391 $
//  Purpose   : gndo wiki templates
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import log from 'uix/logging'
import {TagMatcher} from 'uix/wiki/utils'

// ---Local imports
import {GndPopup} from './components'

// ---Exports

/* a Matcher for <Person/> <Place/> is already implemented in wiki/templates/vlext
also Markdown {person} {place}
*/
export const EntityPopup = TagMatcher(
  'EntityPopup',
  ({text, gnd, applyTemplates, childEls}) => {
    let trigger = <div style={{display: 'inline'}}>{applyTemplates()}</div>
    return <GndPopup gndid={gnd} trigger={trigger} />
  },
  {},
  'Person / Corporate / Place / Subject'
)
